import styles from './LanguageSwitcher.module.css';

export default function LanguageSwitcher({ lang, setLang }) {
  return (
    <div className={styles.wrapper}>
      <button
        className={`${styles.btn} ${lang === 'en' ? styles.active : ''}`}
        onClick={() => setLang('en')}
        aria-label="Switch to English"
      >
        EN
      </button>
      <span className={styles.divider}>|</span>
      <button
        className={`${styles.btn} ${lang === 'ru' ? styles.active : ''}`}
        onClick={() => setLang('ru')}
        aria-label="Переключить на Русский"
      >
        RU
      </button>
    </div>
  );
}
